import { useEffect, useRef } from 'react';

const FUNCTIONS_BASE = import.meta.env.VITE_URL;

/** Budzi kontenery funkcji GET-em `?warmup=1`. Tylko onRequest: callable (onCall) odrzuca GET kodem 400 i zaśmieca logi. */
export const warmupFunction = (fnNames: string | string[]) => {
  const names = Array.isArray(fnNames) ? fnNames : [fnNames];
  names.forEach((fnName) => fetch(`${FUNCTIONS_BASE}/${fnName}?warmup=1`, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-store',
  }).catch(() => {}));
};

export const useWarmup = (functionNames: string | string[]) => {
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const names = Array.isArray(functionNames) ? functionNames : [functionNames];
    warmupFunction(names);
  }, []);
};
